import Service from '@ember/service';
import variantdata from '../data/variantdata';

export default class VariantDataService extends Service {
    data = variantdata;

    currentItemHasVariant(part) {
        return part.split('|').length > 1;
    }

    _foundPartVariant(part) {
        let partArray = part.split('|');
        return partArray.length > 1 ? partArray[1] : null;
    }

    getVariantMetadata(part, type = 'adc') {
        let foundPartVariant = this._foundPartVariant(part);
        return foundPartVariant ? this.data.variants[type][foundPartVariant] : null;
    }

    generateVariantProperties(item, itemObject, type = 'adc') {
        // variant metadata
        item.partCore = item.part.split('|')[0];
        let partsWithVariant = Object.keys(itemObject).filter((part) => {
            var partItems = part.split('|');
            return partItems.length > 1 && partItems[0] === item.partCore;
        });

        if (partsWithVariant.length) {
            item.hasVariant = true;

            if (partsWithVariant.length > 1) {
                item.variants = partsWithVariant
                    .map((part) => this.getVariantMetadata(part, type))
                    .filter((variant) => !!variant);
            } else item.variant = this.getVariantMetadata(partsWithVariant[0], type);
        } else item.hasVariant = false;

        if (item.hasVariant) {
            item.currentVariant = this.getVariantMetadata(item.part, type);
            item.hasCurrentVariant = item.currentVariant != null;
        } else {
            item.currentVariant = null;
            item.hasCurrentVariant = false;
        }
    }
}
